import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { initSlider } from '../../globals/sliders/slider-util';
export default function ({ withSlider }) {
    const lightGalleryKey = '0000-0000-000-0000';
    const breakpointDesktop = '(min-width: 1024px)';
    const mainGallerySliderSelector = '[data-product-main-gallery]';
    const thumbGallerySliderSelector = '[data-product-thumb-gallery]';

    return {
        init() {
            window.require(['matchMedia', 'slick'], (mediaCheck) => {
                this.initializeModalGallery(mediaCheck);

                if (withSlider) {
                    this.mainGallerySlider();
                    this.thumbGallerySlider();
                }

                mediaCheck({
                    media: breakpointDesktop,
                    exit: () => {
                        this.blockGalleryItemEvent();
                    }
                });
            });
        },
        initializeModalGallery(mediaCheck) {
            const productGallery = document.querySelector(
                mainGallerySliderSelector
            );

            mediaCheck({
                media: breakpointDesktop,
                entry: () => {
                    lightGallery(productGallery, {
                        plugins: [lgZoom, lgThumbnail],
                        getCaptionFromTitleOrAlt: false,
                        thumbMargin: 10,
                        thumbWidth: 140,
                        thumbHeight: '140px',
                        licenseKey: lightGalleryKey
                    });
                }
            });
        },
        mainGallerySlider() {
            const mainGallerySliderConfig = {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                asNavFor: thumbGallerySliderSelector
            };

            initSlider(mainGallerySliderSelector, mainGallerySliderConfig);
        },
        thumbGallerySlider() {
            const thumbGallerySliderConfig = {
                slidesToShow: 5,
                slidesToScroll: 1,
                centerMode: false,
                focusOnSelect: true,
                variableWidth: true,
                asNavFor: mainGallerySliderSelector
            };

            return initSlider(
                thumbGallerySliderSelector,
                thumbGallerySliderConfig
            );
        },
        blockGalleryItemEvent() {
            const galleryItems = document.querySelectorAll('.gallery-item');

            galleryItems.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                });
            });
        }
    };
}
